import { render, staticRenderFns } from "./FilmLinksItem.vue?vue&type=template&id=00bad092&scoped=true&"
import script from "./FilmLinksItem.vue?vue&type=script&lang=js&"
export * from "./FilmLinksItem.vue?vue&type=script&lang=js&"
import style0 from "./FilmLinksItem.vue?vue&type=style&index=0&id=00bad092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bad092",
  null
  
)

export default component.exports